import { useQuery } from '@tanstack/react-query';

import { listAttractions } from '~/services/AttractionsService';

import type { ListAttractionsParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseListAttractionsOptions {
  enabled?: boolean;
}

/**
 * Fetches a paginated list of attractions with optional filters.
 */
export function useListAttractions(params: ListAttractionsParams, options: UseListAttractionsOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: attractionQueryKeys.list(params as Record<string, unknown>),
    queryFn: async ({ signal }) => {
      return await listAttractions(params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
